module.exports = __webpack_public_path__ + "media/images/pages/facebook-93fa3dc253c9b12632ca8a045b285584.png";